module.exports = __webpack_public_path__ + "static/media/so-algo-horse2.4dd21003.jpg";